import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import WarrantyClaimForm from '../components/forms/WarrantyClaimForm'

const WarrantyClaim = () => {
  return (
    <Container maxWidth='md' sx={{ py: 2 }}>
      <Box mb={2}>
        <Typography variant='h5'>Warranty Claim Submission</Typography>
      </Box>
      <WarrantyClaimForm />
    </Container>
  )
}

export default WarrantyClaim
